import { ConsentDtoProps } from "./DTOs/ConsentDto"
import { GetAllSupportedBanksDtoProps } from "./DTOs/GetAllSupportedBanksDto"

export const adapterAfterbanksSupportedBanks = (
  bank: GetAllSupportedBanksDtoProps
): GetAllSupportedBanksDtoProps => ({
  countryCode: bank.countryCode,
  extendedInformation: bank.extendedInformation,
  fullName: bank.fullName,
  image: bank.image,
  imageSVG: bank.imageSVG,
  paymentsSupported: bank.paymentsSupported,
  service: bank.service,
  swift: bank.swift,
})

export const adapterAfterbanksConsent = (
  data: ConsentDtoProps
): ConsentDtoProps => ({
  consentId: data.consentId,
  follow: data.follow,
})
